/*!
 * @license
 * Copyright Squiz Australia Pty Ltd. All Rights Reserved.
 */

import React from 'react';

/**
 * Custom file icon with colour.
 */
export const CUSTOM_ICON_FILE_COLOUR = (
  <svg fill="none" height="24" viewBox="0 0 24 24" width="24" xmlns="http://www.w3.org/2000/svg">
    <g clipPath="url(#clip0_108_3405)">
      <path d="M24 0H0V24H24V0Z" fill="transparent" />
      <path
        d="M4.5 0.75C3.25735 0.75 2.25 1.75735 2.25 3V19.5C2.25 20.7426 3.25735 21.75 4.5 21.75H19.5C20.7426 21.75 21.75 20.7426 21.75 19.5V3C21.75 1.75735 20.7426 0.75 19.5 0.75H4.5Z"
        fill="#CEE9D8"
        stroke="#79C292"
      />
      <path
        d="M11.25 4.5H6.75C6.33579 4.5 6 4.83579 6 5.25C6 5.66421 6.33579 6 6.75 6H11.25C11.6642 6 12 5.66421 12 5.25C12 4.83579 11.6642 4.5 11.25 4.5Z"
        fill="#098934"
      />
      <path
        d="M11.25 7.5H6.75C6.33579 7.5 6 7.83579 6 8.25C6 8.66421 6.33579 9 6.75 9H11.25C11.6642 9 12 8.66421 12 8.25C12 7.83579 11.6642 7.5 11.25 7.5Z"
        fill="#098934"
      />
      <path
        d="M17.25 10.5H6.75C6.33579 10.5 6 10.8358 6 11.25C6 11.6642 6.33579 12 6.75 12H17.25C17.6642 12 18 11.6642 18 11.25C18 10.8358 17.6642 10.5 17.25 10.5Z"
        fill="#098934"
      />
      <path
        d="M17.25 13.5H6.75C6.33579 13.5 6 13.8358 6 14.25C6 14.6642 6.33579 15 6.75 15H17.25C17.6642 15 18 14.6642 18 14.25C18 13.8358 17.6642 13.5 17.25 13.5Z"
        fill="#098934"
      />
      <path
        d="M17.25 16.5H6.75C6.33579 16.5 6 16.8358 6 17.25C6 17.6642 6.33579 18 6.75 18H17.25C17.6642 18 18 17.6642 18 17.25C18 16.8358 17.6642 16.5 17.25 16.5Z"
        fill="#098934"
      />
    </g>
    <defs>
      <clipPath id="clip0_108_3405">
        <rect fill="white" height="24" width="24" />
      </clipPath>
    </defs>
  </svg>
);
